import { useEffect, useState } from "react";
import type { Publications } from "./PublicationsContext";
import { PublicationsContext } from "./PublicationsContext";

export const PublicationsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [config, setConfig] = useState<Publications[]>();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const domain = window.compassUrl || import.meta.env.VITE_COMPASS_URL;
        if (!domain) {
          throw new Error("Compass URL not defined");
        }
        const url = `${domain}/frj-publications?token=${window.frjToken || import.meta.env.VITE_FRJ_TOKEN}`;
        const response = await fetch(url);
        const body = await response.json();
        if (!Array.isArray(body)) {
          throw new Error("Invalid response format");
        }
        if (body.some((publication) => !publication.id || !publication.title)) {
          throw new Error("Missing required config values");
        }
        setConfig([...body]);
      } catch (error) {
        console.error("Error fetching config values:", error);
      }
    };
    fetchConfig();
  }, []);

  return (
    <PublicationsContext.Provider value={config || []}>
      {children}
    </PublicationsContext.Provider>
  );
};
